import { updateProfile } from 'firebase/auth'
import { auth } from '@/features/auth/firebaseConfig'
import { useAuth } from '@/features/auth/context/authProvider'

export interface ProfileChanges {
  displayName?: string
  /** Null clears the photo. */
  photoURL?: string | null
}

/**
 * Writes the signed-in owner's name or photo.
 *
 * Both live in Firebase, and the backend reads them from there (it keeps
 * neither), so saving is Firebase's `updateProfile` and no endpoint of ours.
 */
export function useWriteProfile() {
  const { setCurrentUser } = useAuth()

  return async (changes: ProfileChanges) => {
    const user = auth.currentUser
    if (!user) return
    await updateProfile(user, changes)
    // A profile change fires no auth event, so the context, which holds a
    // copy, is refreshed by hand or the sidebar keeps the old name.
    await user.reload()
    setCurrentUser({ ...user })
  }
}

export default useWriteProfile
